import React, { useState, useEffect } from "react";
import Select from 'react-select';
import axios from "axios";
import { getsessionuser } from "../Utils/sessions";
import { Alert, Button, Container, IconButton, Snackbar, TextField } from "@mui/material";
import { AddCircle, Delete, Save } from "@mui/icons-material";
import { primarycolor } from "../Utils/colors";
import Loadingspinner from "../Components/loading";


const Addservice = ({ oncancelfund }) => {

    const Services = [
        { label: <i className='fas fa-dryer me-3' style={{ color: "red" }}> &nbsp;&nbsp;laundry</i>, value: "Laundry" },
        { label: <i className='fas fa-shopping-cart me-3' style={{ color: "red" }}> &nbsp;&nbsp;Shop</i>, value: "Shop" },
        { label: <i className='fas fa-laptop me-3' style={{ color: "red" }}> &nbsp;&nbsp;Software developer</i>, value: "Software developer" },
        { label: <i className='fas fa-camera me-3' style={{ color: "red" }}> &nbsp;&nbsp;Photography</i>, value: "Photography" },
        { label: <i className='fas fa-car me-3' style={{ color: "red" }}> &nbsp;&nbsp;transportation</i>, value: "Transportation" },
        { label: <i className='fas fa-desktop me-3' style={{ color: "red" }}> &nbsp;&nbsp;Cyber</i>, value: "Cyber" },
        { label: <i className='fas fa-lightbulb me-3' style={{ color: "red" }}> &nbsp;&nbsp;Electrician</i>, value: "Electrician" },
        { label: <i className='fas fa-user me-3' style={{ color: "red" }}> &nbsp;&nbsp;Salon</i>, value: "Salon" },
        { label: <i className='fas fa-pen me-3' style={{ color: "red" }}> &nbsp;&nbsp;Art</i>, value: "Art" },
        { label: <i className='fas fa-spoon me-3' style={{ color: "red" }}> &nbsp;&nbsp;Hotel</i>, value: "Hotel" },
        { label: <i className='fas fa-chair me-3' style={{ color: "red" }}> &nbsp;&nbsp;Capentry</i>, value: "Capentry" },
        { label: <i className='fas fa-bolt me-3' style={{ color: "red" }}> &nbsp;&nbsp;Metal work</i>, value: "Metal work" },
        { label: <i className='fas fa-tag me-3' style={{ color: "red" }}> &nbsp;&nbsp;Other</i>, value: "other" },
    ];



    useEffect(() => {
        getlocation();
    }, [])

    //get current user location
    const getlocation = () => {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                setlatitude(position.coords.latitude)
                setlongitude(position.coords.longitude)
            },
            function (error) {
                alert(error.message + ". PLease allow location to continue");
            }
        );

    }


    const user = getsessionuser()

    const [error, setError] = useState(null);
    const [success, setsuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const [error2, seterror2] = useState('');

    let username = user?.username;

    let name1 = username?.substr(0, username.indexOf(' '));
    let name2 = username?.substr(username.indexOf(' ') + 1);


    const [service, setService] = useState('');
    const [agree, setAgree] = useState(false);
    const [fname, setFname] = useState(name1 ? name1 : null);
    const [lname, setLname] = useState(name2 ? name2 : null);

    const [idno, setIdNo] = useState('');
    const [bname, setBname] = useState('');
    const [description, setdescription] = useState('');
    const [subcategory, setsubcategory] = useState([]);
    const [email, setEmail] = useState(user ? user.email : null);
    const [phone, setPhone] = useState(user ? user.phone : null);
    const [itemname, setitemname] = useState('');
    const [itemdescription, setitemdescription] = useState('');
    const [itemprice, setitemprice] = useState('');
    const [campus, setCampus] = useState(user ? user.campus : null);
    const [test, settest] = useState('');
    const [longitude, setlongitude] = useState('');
    const [latitude, setlatitude] = useState('');

    const [typeother, settypeother] = useState('');

    const submit = () => {
        setLoading(true)
        if (!fname | !lname | !idno | !email | !phone | !service | !campus) {
            setLoading(false)
            setError("Fill all fields");
        }
        else if (agree == false) {
            setLoading(false)
            setError("Agree to the terms and conditions")
        } else if (service === "other" && !typeother) {
            setLoading(false)
            setError("Type your service category");
        }

        else {
            setError(null)
            axios.post("https://eazistey.co.ke/API_WEB_HOOKS/Services/register_service_api.php?5$fgk=hh", {
                lname: lname,
                fname: fname,
                email: email,
                phone: phone,
                bname: bname,
                service: service === "other" ? typeother : service,
                subcategory: subcategory,
                description: description,
                idno: idno,
                campus: campus,
                longitude: longitude,
                latitude: latitude
            }).then(response => {
                setLoading(false)
                if (!response.data.message) {
                    setsuccess(response.data.success)
                    setTimeout(() => {
                        oncancelfund()
                    }, 3000);
                } else {
                    setError(response.data.message)
                }
                // 
            }).catch(error => {
                setLoading(false)
                setError("Sorry an error occurred,try again later");
                //if(error.response.status === 401 || error.response.status === 400){}

            });
        }

    }

    //add items to catalogue stack
    const addtostack = () => {
        seterror2(null)

        if (!itemname | !itemdescription | !itemprice) {
            seterror2("fill catalogue fields")
        } else {
            const myObj = { name: itemname, description: itemdescription, price: itemprice, email: user.email };
            //  const myJSON = JSON.stringify(myObj);
            subcategory.push(myObj)
            setitemname('')
            setitemprice("")
            setitemdescription("")
        }
    }

    const update = () => {
        if (test.length < 5) {
            settest("ggggggg")
        } else {
            settest('')
        }

    }

    const textinputstyles = {
        maxHeight: 20,
        marginRight: 5,
        width: "100%",
        marginBottom: 5,
        fontSize: 10
    }


    return (
        <Container sx={{
            backgroundColor: "white",
            marginTop: 5,
            padding: 5,
            borderRadius: 4
        }} maxWidth="md">
            {loading && <Loadingspinner />}
            <Snackbar open={error?.length > 0 && true} autoHideDuration={3000} onClose={() => setError()}>
                <Alert severity="error">{error}</Alert>
            </Snackbar>
            <Snackbar open={success?.length > 0 && true} autoHideDuration={3000} onClose={() => setsuccess()}>
                <Alert severity="success">{success}</Alert>
            </Snackbar>
            <div className="overflowdivwithoutscroll">
                <div className="right2">
                    Business name<br />
                    <TextField id="outlined-basic" sx={textinputstyles} label="Business name" variant="outlined" size="small" value={bname} onChange={(e) => setBname(e.target.value)} /><br />
                    Id number:<br />
                    <TextField id="outlined-basic" sx={textinputstyles} label="Id number" type={"number"} variant="outlined" size="small" value={idno} onChange={(e) => setIdNo(e.target.value)} />
                </div>

                <div className="bottom2">
                    Select category
                    <div style={{ width: "100%" }}>
                        <Select menuPlacement="top" options={Services} onChange={e => setService(e.value)}  ></Select>
                    </div>

                    {service === "other" &&
                        <div>
                            <br />
                            <TextField id="outlined-basic" sx={textinputstyles} label="Type service category" variant="outlined" size="small" value={typeother} onChange={(e) => settypeother(e.target.value)} />
                        </div>
                    }<br />
                    Description:<br />
                    <TextField id="outlined-basic" sx={textinputstyles} multiline label="description" variant="outlined" size="small" value={description} onChange={(e) => setdescription(e.target.value)} />
                    <div>
                        <div className="wrapcatalogue">
                            {subcategory?.map((val, key) => {
                                const removeitem = () => {
                                    var index = subcategory.findIndex(obj => obj?.name == val.name);
                                    delete subcategory[index];
                                    update();
                                }
                                return (
                                    <div key={key} className="catalogueitem">
                                        <IconButton size="small" aria-label="delete" title="delete" onClick={removeitem}>
                                            <Delete color="error" />
                                        </IconButton>
                                        <div style={{
                                            marginTop: 15
                                        }}>
                                            {val.name}<br />
                                            {val.description}<br />
                                            ksh {val.price}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        <hint htmlFor="subject" className=""><b>Catalogue</b></hint>
                        <br />
                        Name:<br />
                        <input type="text" className="inputs12" placeholder="*printing*" value={itemname} onChange={e => setitemname(e.target.value)} /><br />
                        Description:<br /><input type="text" className="inputs12" placeholder="*1 page*" value={itemdescription} onChange={e => setitemdescription(e.target.value)} /><br />
                        Price:<br /> <input type="number" className="inputs12" placeholder="*sh 10* " value={itemprice} onChange={e => setitemprice(e.target.value)} /><br />
                        <text style={{ color: "red" }}>{error2}</text><br />
                        <IconButton size="small" aria-label="add" title="delete" onClick={addtostack}>
                            <AddCircle color="error" />
                        </IconButton>


                    </div>
                    <div style={{ fontSize: 13, color: primarycolor }}>
                        *Note<br />
                        1.You'll be prompted with an mpesa stk push to pay ksh100(Subscription fee per month).
                    </div><br />
                    {error && <div className="error">{error}</div>}
                    <Button variant="outlined" startIcon={<Save />} onClick={submit}>
                        Submit
                    </Button><br /><br />
                    <input type="checkbox" className="form-check-input" value={agree} onChange={e => setAgree(e.target.value)} />
                    I agree to the <a href="/terms">terms and conditions</a><br /><br />
                </div>

            </div>
        </Container>
    );
}

export default Addservice;